import { render, staticRenderFns } from "./upLoadSuccess.vue?vue&type=template&id=53ec2a62&scoped=true&"
import script from "./upLoadSuccess.vue?vue&type=script&lang=js&"
export * from "./upLoadSuccess.vue?vue&type=script&lang=js&"
import style0 from "./upLoadSuccess.vue?vue&type=style&index=0&id=53ec2a62&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec2a62",
  null
  
)

export default component.exports